import { useState } from "react";
import { FormContextDataProps, InvalidFormState, Props, defaultInvalidFormState } from "../../../../types";


const useIncorrectEmployee = <T extends FormContextDataProps<any>, U extends Props<any>>(
) => {
  const [actionColumnAnchorEl, setActionColumnAnchorEl] =
    useState<HTMLElement | null>(null);
  const [state, setState] = useState<InvalidFormState>(defaultInvalidFormState);

  const toggleViewHandler = () => {
    setState((prevState) => ({
      ...prevState,
      toggleView: !prevState.toggleView,
    }));
  };

  const onShowSuccess = (message: string, refetchGrid: boolean = true) => {
    setState((prevState) => ({
      ...prevState,
      ...defaultInvalidFormState,
      showSuccessSnackbar: true,
      successMessage: message,
    }));
  };

  const handleClose = async() => {  
    await setState((prevState)=> ({
      ...prevState,
      formData: null,
      rowIndex: null,
    }));
    setActionColumnAnchorEl(null);
  }

  const handleActionClick = (event: React.MouseEvent<HTMLButtonElement>) =>
    setActionColumnAnchorEl(event.currentTarget);

  const onAddSnackbarClose = () => {
    setState((prevState) => ({
      ...prevState,
      showSuccessSnackbar: false,
    }));
  };  

  const rowEvents = {
    onClick: async (
      e: React.MouseEvent<HTMLElement, MouseEvent>, //needed to correctly get row data
      row: any,
    ) => {
      await setState((prevState)=> ({
        ...prevState,
        formData: row,
      }));
    },
  };

  return {
    state,
    rowEvents,
    actionColumnAnchorEl,
    toggleViewHandler,
    onShowSuccess,
    handleClose,
    handleActionClick,
    onAddSnackbarClose,
    setActionColumnAnchorEl,
  };
};

export default useIncorrectEmployee;
